module.exports = __webpack_public_path__ + "static/assets/c2647b0c280c9b54a32bcc49b258d9c9.svg";